import { render, staticRenderFns } from "./group-detail-workspace.vue?vue&type=template&id=2d814a5a&"
import script from "./group-detail-workspace.ts?vue&type=script&lang=js&"
export * from "./group-detail-workspace.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports